import React from "react";
import styled from "styled-components";
import { isEmpty } from "lodash";
import {
  Scroller,
  ScrollerContent,
} from "@sonder/ui/source/styled/fragments/Scroller";
import { Table } from "@sonder/ui/source/styled/fragments/Table";
import { sizes } from "@sonder/ui/source/styled/theme";
import { BuildingsData } from "core/queries/GetBuildingSupervisors";
import { AddSupervisorButton } from "supervisors/components/AddSupervisorButton";
import { Row } from "supervisors/components/Row";
import { EmptyRow, TaskTitle } from "tasks/components/TaskList";

const StyledScroller = styled(Scroller)`
  border-radius: 0 0 0.3rem 0.3rem;
`;

export const BuildingSupervisorsListOuterContainer = styled.div`
  box-sizing: border-box;
  max-width: ${sizes.listWidth};
  margin: 0 auto;
  width: 100%;
  padding: 1rem 1rem 1rem 1.5rem;
`;

interface BuildingSupervisorsListProps {
  building: BuildingsData;
  loading?: boolean;
}

export const BuildingSupervisorsList = ({
  building,
  loading = false,
}: BuildingSupervisorsListProps) => {
  const { cleaningSupervisors: supervisors } = building;
  return (
    <BuildingSupervisorsListOuterContainer>
      <TaskTitle
        count={supervisors.length}
        isCollapsed={false}
        title={building.shortInternalRef}
      >
        <AddSupervisorButton building={building} />
      </TaskTitle>
      <StyledScroller>
        <ScrollerContent>
          <Table columns="3.5rem 20rem 1fr">
            {isEmpty(supervisors) && (
              <EmptyRow
                label="No supervisors for this building"
                loadingLabel={loading ? "Loading..." : undefined}
              />
            )}
            {supervisors
              .sort((a, b) => {
                return (a.name || "") < (b.name || "") ? -1 : 1;
              })
              .map((supervisor, index) => (
                <Row
                  building={building}
                  key={supervisor.id}
                  lastRow={index === supervisors.length - 1}
                  loading={loading}
                  supervisor={supervisor}
                />
              ))}
          </Table>
        </ScrollerContent>
      </StyledScroller>
    </BuildingSupervisorsListOuterContainer>
  );
};
